
import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { countries } from 'src/app/resources/countries';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Modulo } from 'src/app/models/modulo.model';
import { ModuloArmario } from 'src/app/models/locker.model';


@Component({
    selector: 'app-modules-form-component',
    templateUrl: './modules-form.component.html'
})
export class ModulesFormComponent extends DialogContentBase implements OnInit {
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public compartimentos: Array<any> = [

    ];
    public linhas: Array<any> = [];
    public colunas: Array<any> = [];
    public listItems: Array<Modulo> = [];
    public listItemsAux: Array<Modulo> = [];
    public listItems2: Array<number> = [];
    public listItemsEletronica: Array<any> = [{ nome: 'MegaLocker', value: true }, { nome: 'Locker', value: false }];
    public formValue: ModuloArmario = {
        id: 0,
        refArmario: 0,
        nomeArmario: '',
        refModeloModulo: 0,
        nomeModeloModulo: '',
        internalID: 0,
        megaLocker: undefined,
        enderecoPrincipal: 0
    };


    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService, private api: ApiService, public override dialog: DialogRef) {
        super(dialog);

        this.formGroup = new FormGroup({

            refModeloModulo: new FormControl(null, [Validators.required]),
            megaLocker: new FormControl(undefined) ///new FormControl(false)

        });
        // this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');

    }

    ngOnInit() {
        this.api
            .getRequest<BaseHttpResponse<Modulo[]>>("Armario/GetModulos")
            .then((data) => {
                this.listItemsAux = data.value;
                var hasMainModule = false;
                this.listItems2.forEach(element => {
                    var idx = this.listItemsAux.map(x => x.id).indexOf(element);
                    if (idx > -1) {
                        if (this.listItemsAux[idx].principal === true) {
                            hasMainModule = true;
                        }
                    }
                });

                if (hasMainModule) {
                    this.listItems = this.listItemsAux.filter(m => !(m.principal));
                } else {
                    this.listItems = this.listItemsAux;
                }
            })
            .catch((err) => { });
    }

    // ngAfterViewInit() {
    //     this.setAvatar();

    // }

    public setFormValues() {
        // const form = localStorage.getItem('form');
        // if (form) {
        //     this.formValue = JSON.parse(form);
        // }
        // var ptValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
        // var enValue =  this.formValue.traducoes.filter(_ling=> _ling.refLingua === 2)[0].valor;
        // var frValue =  this.formValue.traducoes.filter(_ling=> _ling.refLingua === 3)[0].valor;

        this.formGroup = new FormGroup({
            refModeloModulo: new FormControl({ id: this.formValue.refModeloModulo }, [Validators.required]),
            megaLocker: new FormControl(false)
        });
    }

    public placeHolder: any = {
        nome: "",
        value: undefined,
    };

    public setAvatar() {
        // this.avatars = document.querySelectorAll('.k-avatar .k-avatar-image');
        // const avatarImg = localStorage.getItem('avatar');
        // if (avatarImg) {
        //     this.avatars.forEach((avatar: any) => {
        //         avatar.style['background-image'] = `url("${avatarImg}")`;
        //     });
        // }
    }

    public saveChanges(): void {
        //this.dialog.close();
        this.formValue.refModeloModulo = this.formGroup.controls['refModeloModulo'].value.id;
        this.formValue.nomeModeloModulo = this.formGroup.controls['refModeloModulo'].value.nome;
        this.formValue.megaLocker = this.formGroup.controls['megaLocker'].value;

        this.dialog.close({ save: true, data: this.formValue });
        //         this.formGroup.markAllAsTouched();

        // this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor =this.formGroup.controls['pt'].value ;
        // this.formValue.traducoes.filter(_ling=> _ling.refLingua === 2)[0].valor =this.formGroup.controls['en'].value;
        // this.formValue.traducoes.filter(_ling=> _ling.refLingua === 3)[0].valor=this.formGroup.controls['fr'].value;
        //  this.formValue.refLocal=this.formGroup.controls['site'].value.id



        //         this.api.save<BaseHttpResult>('Equipa/SaveEquipa',this.formValue).then(res => {
        //             if (res.ok) {



        //             this.notificationService.show({
        //                 content:this.customMsgService.translate('registoGravadoComSucesso') ,
        //                 animation: { type: 'slide', duration: 500 },
        //                 position: { horizontal: 'center', vertical: 'bottom' },
        //                 type: { style: 'success', icon: true },
        //                 hideAfter: 2000
        //             });
        //             this.dialog.close();
        //             } else {
        //             //   const sb = this.snackBar.open(res.message, "Fechar", {
        //             //     verticalPosition: "top",
        //             //     panelClass: ["red-snackbar"],
        //             //   });
        //             }
        //           });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    public selectionChange(value: Modulo): void {
        this.compartimentos = value.compartimentos;
        this.linhas = value.linhas;
        this.colunas;
    }
}
